const locale = {
  Enabled: "Enabled",
  Disabled: "Disabled",
  IVRREJECTED: "IVR Rejected",
  NAV: {
    HOME: "Home",
    APPLY: "Apply",
    HOW_IT_WORKS: "How it works",
    ABOUT: "About",
    FINANCIAL_PRODUCT: "Financial product",
    CONTACT: "Contact",
    FAQS: "FAQs",
  },
  SIGN_IN: {
    LOGIN: "LOG IN",
    TITLE: "LOGIN",
    DESCRIPTION: "FAST, SECURE AND EFFORTLESS",
    FIELDS: {
      ID: "National ID/ Iqama",
      PASSWORD: "Password",
    },
    FORGOT_PASSWORD: "Forgot password?",
    DONT_HAVE_AN_ACCOUNT: "DON'T HAVE AN ACCOUNT?",
    SIGN_UP: "SIGN UP",
    ID_10_DIGITS: "ID must be exactly 10 digits.",
    CANNOT_BE_EMPTY: "Cannot be empty.",
    CREDENTIAL_SUCCESS: "Credentials verified successfully",
    SOMETHING_WENT_WRONG: "Something went wrong",
    TIMEOUT: "Timeout. Please, sign-in again",
    VERIFICATION_COMPLETE: "Verification complete",
    WRONG_OTP: "Wrong OTP!",
    SEND: "Send",
    RESEND_CODE: "Resend code",
    WE_HAVE_SENT: "We've sent your one-time password (OTP) by SMS",
    HELP_LINE_CALL: "Call for support: 920005477",
    CALL_FOR_SUPPORT: "Call for support",
    EMAIL_US_AT: "Email us at",
    TICKET_SUBMISSION: "Ticket Submission",
    OR: "OR",
    HELP_LINE_EMAIL: "email us at: info@tamweel-aloula.com",
    INVALID_CREDENTIALS: "Invalid credentials (ID or password).",
    ACCOUNT_DELETED: "Account has been deleted.",
    // ACCOUNT_LOCKED: '',
    DEVICE_REGISTRATION_LIMIT_REACHED:
      "Device registration limit has been met.",
    IVR_NOT_VERIFIED: "Device is not verified on call.",
    DEVICE_NOT_REGISTERED: "This device is not registered.",
    // OTP_SEND_FAILED: '',
    LOGIN_FAILED: "An unexpected error occurred, Please try again later.",
    HELP_AND_SUPPORT: "Help And Support",
    CHANGE_MOBILE_NUMBER: "Change Mobile Number",
    CHANGE_MOBILE_DESC:
      "Enter your details below to update your registered mobile number.",
    NATIONAL_ID: "National ID / Iqama",
    NATIONAL_ID_PLACEHOLDER: "242111111111112",
    OLD_MOBILE_NUMBER: "Old Mobile Number",
    NEW_MOBILE_NUMBER: "New Mobile Number",
    MOBILE_NUMBER_PLACEHOLDER: "232323232",
    SUBMIT: "Submit",
    PROCESSING: "Processing...",
    CHANGE_MOBILE_SUCCESS: "Mobile number updated successfully!",
    SOMETHING_WENT_WRONG: "Something went wrong!",
    NATIONAL_ID_REQUIRED: "National ID is required",
    OLD_MOBILE_REQUIRED: "Old mobile number is required",
    NEW_MOBILE_REQUIRED: "New mobile number is required",
    INVALID_NATIONAL_ID: "Please enter a valid 10-digit National ID",
    INVALID_OLD_MOBILE: "Please enter a valid 9-digit old mobile number",
    INVALID_NEW_MOBILE: "Please enter a valid 9-digit new mobile number",
    MOBILE_SAME_ERROR: "New mobile number must be different from the old one",
    OTP_TITLE: "OTP",
    OTP_DESC: "We sent your one-time password (OTP) by SMS.",
    RESEND_CODE: "Resend Code",
    CALL_SUPPORT: "Call for support:",
    EMAIL_SUPPORT: "Email us at:",
    INVALID_OTP: "Please enter a valid verification code",
    OTP_VERIFIED: "OTP verified successfully!",
    OTP_RESENT: "A new code has been sent!",
    MOBILE_NUMBER_UPDATED: "Mobile Number Updated",
    SUCCESSFULLY: "Successfully",
    VERIFYING: "Verifying...",
    SUBMIT: "Submit",
    SENDING: "Sending...",
  },
  SIGN_UP: {
    TITLE: "SIGN UP",
    DESCRIPTION: "A step closer to financial solutions",
    FORM_DESCRIPTION: "Please, fill-out the following form",
    HELP_LINE:
      "Call for support: 920005477 or email us at: info@tamweel-aloula.com",
    DONE: "Ok",
    PRIVACY: {
      TITLE: "Privacy notice",
      ACCEPT: "Accept",
      DECLINE: "Decline"
    },
    LABELS: {
      ID: "National ID/ Iqama",
      PHONE: "Phone number registered in Absher",
      EMAIL: "Email",
      CONFIRM_EMAIL: "Confirm Email",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
    },
    FIELDS: {
      ID: "ID",
      PHONE: "9665XXXXXXXX",
      EMAIL: "Email",
      CONFIRM_EMAIL: "Confirm Email",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      HIJRI_DATE: "Hijri Date Of Birth",
      GEORGIAN_DATE: "Georgian Date Of Birth",
      SELECT_DATE_TYPE: "Select Date Type",
    },
    TERMS_AGREE: "I have read and agreed to the",
    TERMS_MODEL: {
      TITLE: "Terms and Conditions",
      CONTENT: `
<div style="line-height: 1.8; white-space: pre-wrap;">
 I, the applicant, declare that all documents, data, and information submitted are authentic, genuine, and legally valid. I acknowledge that submitting forged, fabricated, altered, or misleading documents constitutes fraud and may result in rejection of the application, termination of any approved service, immediate demand for repayment of any granted financing, reporting to competent authorities, and legal prosecution under the applicable laws of the Kingdom of Saudi Arabia.

<strong>1.</strong> User: means the customer or person authorized by the customer and authorized by the company to enter to provide data and documents on the product order.

<strong>2.</strong> The company is committed to implementing all instructions and transactions received from the user electronically, provided that they are compatible with the company's work system, the instructions of the competent official authorities and the financing laws at its absolute discretion.

<strong>3.</strong> This service is done electronically using digital authentication and may not be challenged electronically.

<strong>4.</strong> The Company has the right to restrict any operations carried out by the User electronically to the Contract and the Client is obliged to pay the fees determined by the Company for the use of this Service, which may be amended from time to time at its absolute discretion.

<strong>5.</strong> I, the applicant, acknowledge the electronic responsibility, and full responsibility of the person authorized by me to use the electronic services and conduct full transactions through the user and the password and everything related to the requirements of maintaining them, and not to disclose the number to any party, even the company's employee or any other person or entity.

<strong>6.</strong> I, the applicant, acknowledge that the Company, its affiliates and the Company's employees are not responsible for any losses, damages, financial claims or otherwise resulting from the use of the user's account and my password, and I am obligated to notify the Company immediately upon the occurrence of anything contrary by a notarized letter from me of the incident if it becomes clear to me that the password has become known to others so that the Company can take the necessary action, I shall be responsible for all transactions and instructions issued by the user's account until the company receives the written communication and obtains a written statement from it.

<strong>7.</strong> I, the applicant, acknowledge the full confidentiality of the user's account, information and financing transactions, and I am responsible for any unauthorized use and bear all the consequences that may result from this, whether direct or indirect.

<strong>8.</strong> I, the applicant, acknowledge that the intellectual property rights of the software and documents of the electronic services provided are not owned and agree not to allow me as a user to copy, modify the programs, etc., or to download or transfer the electronic services programs to a similar website.

<strong>9.</strong> I, the applicant, acknowledge the possibility of viewing the status of the application and knowing the status (acceptance or rejection) through this service, and I also acknowledge that the company has no obligations when the application is not accepted for any reason.

<strong>10.</strong> Tamweel Aloula has the right to resort to the competent judicial authorities and claim compensation for any damage or expenses incurred as a result of reviewing or approving a financing application, if it is found that any of the information or documents submitted are incorrect, misleading, incomplete, forged, altered, submitted with fraudulent intent, or not in compliance with the company’s internal terms and conditions or the regulatory requirements of the relevant authorities.

<strong>11.</strong> I agree to receive all correspondence and notifications related to the request submitted by me by e-mail, text messages and contact, and commit to taking all necessary precautions for the confidentiality of correspondence, and I am responsible for any violations that may result from this.

<strong>12.</strong> I acknowledge the company's right to record all communications and instructions received through the electronic services, and that these audio recordings are evidence of the information contained therein in the event of using the toll-free number or the customer services department.

<strong>13.</strong> I confirm that the income sources and supporting documents I submitted to obtain financing are genuine and accurate, and have not been altered or manipulated in any way. Any false information or forgery will be considered a serious violation of these terms and may result in legal action. I also agree that Tamweel Aloula has the right to obtain any information it requires from the service provider, SIMAH.

<strong>14.</strong> I, the applicant, acknowledge that any delay caused by the Company to claim any right or authority contained in these Terms shall not be considered a waiver of such right or power and the Company shall have the right to claim it at any time.

<strong>15.</strong> I, the applicant, acknowledge that the Company reserves the right to amend these Terms, and the continued use of the User by me constitutes my acceptance of the amendment.

<strong>16.</strong> These Terms shall be implemented and interpreted in accordance with the provisions of the laws and regulations in force in the Kingdom of Saudi Arabia, and all that is not provided for shall be in accordance with Saudi regulations and disputes related to this service shall be resolved before the competent Saudi courts.

<strong>17.</strong> The customer "applicant" acknowledges during the period of submitting the financing application with Tamweel Al Oula Company and until obtaining this not to apply with any other party to obtain financing or any financial obligation, which may affect his credit history, and also acknowledges and undertakes his commitment to the regulations, controls and instructions of the Saudi Central Bank and all other legislative controls, In case of violation, Tamweel Al Oula Company has the right to refuse to grant him the required financing and sue the customer "applicant" with any official authority and claim any amounts, fees or compensation that may result from submitting this application. Any material misrepresentation, concealment of information, or submission of fraudulent or fabricated documents shall be deemed a fundamental breach of the contractual relationship between the parties.

<strong>18.</strong> The customer also acknowledges and undertakes to bear full responsibility for submitting the financing application with Tamweel Al Oula Company and after obtaining credit approval when submitting the financing application and approving it by granting it to the financing product provided by him, and acknowledges his full knowledge of the consequences of exceeding the debt burden ratio permitted by law during the period of validity of the financing contract and for all that results from such override and acknowledging that in the event that it occurs to the customer, by submitting financing applications with other financing bodies and obtaining simultaneously or at any time later additional loans that exceed the total obligations of his total obligations beyond the permissible limit, he bears full responsibility for what has been submitted and is considered a breach of the contractual terms with a finance company and thus bears the payment of the full amount agreed upon in the contract, and the company reserves the right to claim immediately and pay the full amount.

<strong>19.</strong> The Company reserves the right to report any suspected fraud to the competent authorities in the Kingdom of Saudi Arabia and to pursue civil and criminal remedies as permitted by applicable laws.

<strong>20.</strong> The Company has the right to temporarily freeze or suspend access to the Online or Mobile account in the event of account inactivity, expiration of the customer’s ID, or multiple failed access attempts. The customer shall be informed of the action taken and advised on the necessary steps to restore or continue the use of the service.

<strong>21.</strong> The Company has the right to block or restrict access to the Online or Mobile account if there is any suspicion of fraudulent activity, misrepresentation, or unauthorized use. The customer acknowledges that such actions may be taken at the sole discretion of the Company to protect its systems and services.

<strong>22.</strong> The Company reserves the right to initiate legal proceedings, including civil or criminal claims, in the event that the customer is found to have committed fraud, submitted falsified documents, or engaged in any deceptive practices in relation to the services provided. The customer acknowledges full responsibility for any fraudulent actions and the resulting legal and financial consequences.
</div>
    `,
      ACTION: "Agree",
      ACCEPTED: "Accepted",
    },
    NATIONAL_INFORMATION_ACCEPTENCE:
      "Allow usage of services of the National Information Center for identity verification.",
    ALREADY_ACCOUNT: "ALREADY HAVE AN ACCOUNT?",
    NEWS_AND_OFFERS_CONSENT:
      "I would like to receive the latest news and personalized offers from Tamweel Aloula",
    SIGN_IN: "SIGN IN",
    FROM_BUTTON: "Continue",
  },
  COMPLAINTS: {
    TITLE: "Help and support",
    COMPLAINT_SUBMISSION: "Complaint Submission",
    COMPLAINT_DESC: "Please fill out the form below to submit your complaint.",
    FIELDS: {
      FULL_NAME: "Full Name",
      ID: "National ID/ Iqama",
      EMAIL: "Email",
      PHONE: "Phone Number",
      COMPLAINT_DETAILS: "Complaint Details",
      CITY: "City",
    },
    PLACEHOLDERS: {
      FULL_NAME: "EX. Ahmed",
      ID: "EX: 25174XXXXX",
      EMAIL: "EX: Name@mail.com",
      PHONE: "EX: 96645555555",
      COMPLAINT_DETAILS: "please describe your problem...",
      CITY: "EX: Riyadh",
    },
    VERIFY: "Verify Phone Number",
    VERIFY_DESC: "We sent your one-time password (OTP) by SMS",
    VALIDATE: "Validate OTP",
    SUBMIT: "Submit Complaint",
    PHONE_VERIFIED: "Phone number verified!",
    VALIDATION: {
      NAME_MAX_LENGTH: "Name must be less than 100 characters",
      TIMEOUT: "Your OTP has timed out!",
      NAME_ONLY_LETTERS: "Name must contain only letters",
      NAME_REQUIRED: "Name is required",
      PHONE_FORMAT: "Phone number must be 9665XXXXXXXX",
      PHONE_REQUIRED: "Phone number is required",
      EMAIL_FORMAT: "Email must be in the format of Name@mail.com",
      EMAIL_MAX_LENGTH: "Email must be less than 55 characters",
      EMAIL_REQUIRED: "Email is required",
      DETAILS_MAX_LENGTH: "Details must be less than 4000 characters",
      DETAILS_ALLOWED_CHARS:
        "Details must contain Arabic or English letters, numbers, spaces, commas, and periods",
      DETAILS_REQUIRED: "Details are required",
      ID_FORMAT: "ID must be 10 digits",
      ID_REQUIRED: "ID is required",
      ID_START_WITH: "ID must start with 1 or 2",
      CITY_MAX_LENGTH: "City must be less than 100 characters",
      CITY_ONLY_LETTERS: "City must contain only letters",
    },
    SUBMITTED: "Submit!",
    SUCCESS_PARA1: "Your complaint has been submitted successfully.",
    SUCCESS_PARA2: "We will review it and get back to you shortly.",
    BACK: "Back to Login",
  },
  HOME: {
    GREETINGS: "Greetings",
    LAST_LOGIN: "Last login",
    CREATE_NEW: "Apply Now",
    REQUEST: "Active Request",
    APPL_NO: "Application No",
    PRODUCT: "Product",
    CONTRACT: "Contract",
    STATUS: "Status",
    VIEW: "View application",
    COMPLETE: "Complete Request",
    SEARCH: "Search name, amount, etc.",
    ARE_YOU_SURE: "Are you sure you want to logout?",
    Hi: "Hi",
    DIGITAL_APP_ID: "Application ID",
    CONTRACT_SIGNING: "Contract signing",
    VIEW_CONTRACT: "View Contract",
    UPLOAD_DOCUMENT: "Upload Document",
    APPLICATION_TIME_LINE: "Application Timeline",
    VIEW_OFFER: "View offer",
    NO_REQUESTS: "No requests yet",
    EXPLORE_SERVICES: "Explore Our Services & Apply:",
    AUTO: "Auto Leasing",
    PERSONAL: "Personal Financing",
    MICRO: "Micro Finance",
    AUTO_DESC:
      "Compatible With Islamic Law And With A Competitive Profit Margin",
    MOTO_DESC:
      "Compatible With Islamic Law And With A Competitive Profit Margin",
    PERSONAL_DESC:
      "Compatible With Islamic Law And With A Competitive Profit Margin",
    MICRO_DESC:
      "Compatible with Islamic law and with a competitive profit margin",
    PRODUCT_TITLE: "Finance Products",
    SCHOOL_DENTAL_PRODUCTS_TITLE: "Auto Leasing & Moto Products",
    SCHOOL_PRODUCTS_TITLE: "Education Products",
    DENTAL_PRODUCTS_TITLE: "Tamweel Dental Products",
    HEALTHCARE_TITLE: "Healthcare",
    MICRO_PRODUCTS_TITLE:
      "Empowering Your Needs with Flexible Microfinance Solutions",
    MICRO_SUB: "Tamweel Micro Finance",
    CARDS_TITLE: "Voucher Cards",
    SCHOOL_BANNER_TITLE: "Education Financing",
    // SCHOOL_BANNER_TITLE:
    //   "Simplify Your Educational Payment With Tamweel Aloula",
    SEE_MORE: "See More",
    SCHOOL_ALNUBALAA: "ALNUBALAA EST",
    SCHOOL_DIGITAL_AL_MUNSIYAH: "Digital Culture Schools - Al-Munsiyah",
    SCHOOL_DIGITAL_IRQAH: "Digital Culture Schools - Irqah",
    SCHOOL_MINNHA: "Minnha Platform",
    SCHOOL_INTERLUDE: "Interlude",
    SCHOOL_ACHET: "Advanced Consultant Center for Health Training",
    SCHOOL_ADCCC: "Advanced Dental Care Consultants Clinics Center",
    SCHOOL_YASCHOOLS: "YaSchools Company",
    SCHOOL_KHOBAR: "Kifah School Al-Khobar",
    SCHOOL_RIYADH: "Kifah School Al-Riyadh",
    SCHOOL_SADA_ABDA: "Sada Al-Abdaa Educational",
    SCHOOL_AL_MASHAEL: "AL Mashael School",
    SCHOOL_AL_MOSA: "Almoosa College of health Science",
    SCHOOL_AL_MANA: "MOHAMMED ALMANA COLLAGE OF MEDICAL SCIENCES",
    DENTAL_BANNER_TITLE: "Effortless Dental Care with Tamweel Aloula",
    KENZEL_DENTAL: "Kenzel Dental Lab",
    MOTO: "Moto Finance",
    FEATURE_PRODUCTS: "Featured Products",
    EDUCATIONAL_PRODUCTS_TITLE: "Educational",
    FURNITURE_PRODUCTS_TITLE: "Furniture",
    ELECTRONICS_PRODUCTS_TITLE: "Electronics",
    NO_FEATURED_PRODUCTS:
      "Currently, there are no products under this category",
    VIEW_ALL: "View All",
  },
  OTHER_SERVICES: {
    TITLE: "Other Services",
    VEHICLE_TITLE: "Vehicle Services",
    SUBTITLE: "Our digital services help you complete your requests with ease.",
    PAGE_TITLE_LEAD: "Other",
    PAGE_TITLE_HIGHLIGHT: "Services",
    APPLY_NOW: "Apply Now",
    COMING_SOON_TITLE: "Coming Soon",
    COMING_SOON_DESC:
      "Something exciting is coming soon. We're preparing new services to serve you better. Check back soon for updates.",
    CONTINUE: "Continue",
    SELECT_APPLICATION: "Please select one application",
    APPLICATION_ID: "Application ID",
    NEXT: "Next",
    BACK: "Back",
    SUBMIT: "Submit",
    REVIEW_RESTRUCTURE: "Review and confirm your restructuring request",
    REVIEW_TOPUP: "Review and confirm your Topup request",
    REVIEW_EARLY_SETTLEMENT: "Review and confirm your Early Settlement request",
    REVIEW_CLEARANCE_LETTER: "Your clearance letter is ready to download.",
    OUTSTANDING_AMOUNT: "Outstanding Amount",
    REMAINING_TENURE: "Remaining tenure",
    MONTHS_SUFFIX: "Months",
    PLEASE_SELECT_TENURE: "Please select tenure",
    TENURE_IN_MONTHS: "Tenure (in months)",
    TENURE_PLACEHOLDER: "Ex: 6 Months",
    TOPUP_AMOUNT: "Topup Amount",
    EARLY_SETTLEMENT_AMOUNT: "Early Settlement Amount",
    UPLOAD_DOCUMENT: "Upload Document",
    UPLOAD_DOC_HINT: "(Only PDF files allowed, up to 3 MB)",
    DOCUMENT: "Document",
    UPLOAD: "Upload",
    SUBMIT_SUCCESS_TITLE: "Request Submitted Successfully – Verify Your Application",
    SUBMIT_SUCCESS_MSG:
      "Please answer the IVR call to proceed with submitting your application.",
    SERVICING_SUCCESS_TITLE: "Request Submitted Successfully",
    SERVICING_SUCCESS_MSG:
      "Your request has been received. Tamweel will review it and contact you with the outcome.",
    REVIEW_BUYOUT: "Review and confirm your Buyout Request",
    BUYOUT_DEBT_TITLE: "Please enter Debt information to continue",
    ENTITY_ORGANIZATION: "Entity / Organization",
    ENTITY_PLACEHOLDER: "Enter entity name",
    AMOUNT: "Amount",
    OTHER_BANK_IBAN: "Other bank IBAN",
    OTHER_BANK_TENURE: "Other bank tenure (in months)",
    TENURE_MONTHS_PLACEHOLDER: "Ex: 24",
    IBAN_PLACEHOLDER: "Ex: SA12321",
    EXTRA_AMOUNT: "Extra Amount",
    ENTER_IBAN: "Enter IBAN",
    DEBT_PROOF_LETTER: "Debt Proof Letter",
    REVIEW_PARTIAL_SETTLEMENT: "Review and confirm your Partial Settlement request",
    REPAYMENT_TYPE: "Repayment type",
    REPAYMENT_TYPE_PLACEHOLDER: "Select a repayment type",
    REPAYMENT_PRINCIPAL_DECREASE: "Principal Decrease",
    REPAYMENT_COMPRESSION: "Compression Repayment",
    RECALCULATION_METHOD: "Recalculate by",
    RECALCULATION_PLACEHOLDER: "Select a recalculation method",
    RECALC_TERM: "Shorten the term",
    RECALC_INSTALLMENT: "Reduce the instalment",
    NO_OF_INSTALLMENTS: "Number of instalments",
    REVIEW_CANCELLATION: "Review and confirm your Finance Cancellation request",
    REVIEW_FINANCE_DETAILS: "Review your finance details",
    CANCELLATION_FEES: "Finance cancelation fees",
    CANCELLATION_NOT_AVAILABLE_IJARAH:
      "Finance cancellation is not available for Ijarah products.",
    SELECT_REGION: "Please Select a Region",
    REGION_BAHRAIN: "BAHRAIN",
    REGION_GCC: "GCC",
    REGION_JORDAN: "Jordan",
    THREE_MONTH_AUTHORIZATION: "3-Month Authorization",
    THREE_MONTH_INSURANCE: "3-Month Insurance",
    ADHOC_SUCCESS_TITLE: "Your request has been submitted successfully.",
    ADHOC_SUCCESS_MSG:
      "Dear customer, SADAD link has been shared with you, kindly check Sadad payment, proceed with payment.",
    DOCUMENT_PENDING_TITLE: "Your letter is being prepared",
    DOCUMENT_PENDING_MSG:
      "We have requested your letter. It is not ready yet — please check again in a few moments.",
    CHECK_AGAIN: "Check Again",
    PDF_DOCUMENT: "PDF Document",
    VIEW: "View",
    DOWNLOAD: "Download",
    ERR_APPLICATION_NOT_FOUND: "We couldn't find that application. Please select another one.",
    ERR_APPLICATION_FORBIDDEN: "This application isn't available on your account.",
    ERR_OPERATION_IN_PROGRESS:
      "A similar request is already being processed. Please wait a moment and try again.",
    ERR_RATE_LIMIT: "You've made too many requests. Please try again later.",
    ERR_REQUEST_FAILED: "We couldn't submit your request right now. Please try again.",
  },
  CREATE_REQUEST: {
    OF: "of",
    STEPS: "Steps",
    AUTO: "Auto Loan",
    CANCEL: "Cancel",
    CANCEL_REQUEST: "Cancel request?",
    CONFIRM: "Confirm",
    ARE_YOU_SURE_REQUEST: "Are you sure you want to cancel the request?",
    DOCUMENT: "Document",
    CLICK_TO_UPLOAD: "Click to upload file",
    EMPLOYMENT_DETAILS: "Employment Details",
    FINANCIAL_DETAILS: "Financial Details",
    NEXT: "Next",
    SALES_REFERENCE: "Sales Reference",
    DO_YOU_SALE_REFERENCE: "Do you have a sales person reference?",
    EXACTLY_8_ALLOWED: "Exactly 8 digits are allowed.",
    SALES_PERSON_REF: "Sales person reference",
    LOAN_DETAILS: "Loan Details",
    PERSONAL_DETAILS: "Personal Details",
    GREAT: "Great!",
    YOUR_REQUEST: "Your request has been",
    SUBMITTED_FOR_REVIEW: "submitted for review.",
    THANKS_FOR_APPLYING: "Thank you for applying.",
    APP_NO: "Application number",
    FEEDBACK: "Your feedback helps us make things better!",
    THANKS_FOR_FEEDBACK: "Thanks for your feedback",
    WRITE_COMMENT: "Write Your Comment",
    ADD_COMMENT: "Add Comment",
    COMMENT_SUB: "Feel free to say how was your journey",
    ONLY_ONE_MINUTE: "This will only take a minute.",
    DONE: "Done",
    WE_WILL_GET_BACK: "We will get back to you soon.",
    KINDLY_MESSAGE: "Kindly contact our sales team",
    FURTHER_ASSISTANCE: "920005477 for further assistance.",
    Full_Name: "Full Name",
    Street_Name: "Street Name",
    Street_Name_AR: "Street Name (Arabic)",
    Building_Num: "Building Number",
    Additional_Num: "Additional Number",
    District_Name: "District Name",
    Post_Code: "Post Code",
    street_name_required: "Street name is required",
    street_name_max_150: "Street name cannot exceed 150 characters",
    street_name_ar_max_150: "Street name (Arabic) cannot exceed 150 characters",
    buildingnum_required: "Building number is required",
    additional_name_required: "Additional number is required",
    District_name_required: "District name is required",
    Post_code_required: "Post code is required",
    Post_code_only_number: "Post code must be a number",
    building_num_only_number: "Building number must be a number",
    Post_code_six_digits: "Post code cannot exceed 6 digits",
    Post_code_four_digits_min: "Post code cannot be less than 4 digits",
    ID_Expiry_Date: "ID Expiry Date",
    IBAN: "IBAN",
    Gender: "Gender",
    Employment_type: "Employment type",
    Education_Level: "Education Level",
    Resident_Status: "Resident Status",
    Employment_Sector: "Employment Sector",
    Occupation: "Occupation",
    Joining_Date: "Joining Date",
    PEP_Relation:
      "Are you a Political Exposed Person? Or do you have a first-degree or second-degree relationship with a Political Exposed Person?",
    Real_Benificiary: "Are you the real beneficiary from the finance?",
    Real_Benificiary_Name: "Real benificiary name",
    Related_Party:
      "Do you have a first-degree relationship with a board member, committee members or senior executives?",
    Party_Postion: "Position",
    pep_relation_required: "This field is required",
    PEP_TOOLTIP_TITLE: "PEP (Politically Exposed Person):",
    PEP_TOOLTIP_CONTENT:
      "A PEP is an individual who holds (or has held) a prominent public position or a high-ranking government role. Because of their influence and access to public funds, they may pose a higher risk for involvement in bribery, corruption, or money laundering.\nExamples: ministers, members of parliament, senior executives in state-owned companies, high-ranking military officials.",
    real_benificiary_required: "This field is required",
    related_party_required: "This field is required",
    party_position_required: "This field is required",
    Type_of_loan: "Type of finance",
    Facility: "Facility",
    Requested_loan_amount: "Requested finance amount",
    SalesRef: "Sales Reference ID (Optional)",
    ReferenceID: "Reference ID (Optional)",
    Requested_loan_amount_: "Requested finance amount",
    Tenure_: "Tenure (in months)",
    Tenure: "Tenure (in months)",
    Food_expenses: "Food expenses",
    Housing_expenses: "Housing expenses",
    Domestic_workers: "Domestic workers",
    Education_expenses: "Education expenses",
    Health_care_expenses: "Health care expenses",
    Communication_and_transportation_expenses:
      "Communication and transportation expenses",
    Insurance_expenses: "Insurance expenses",
    Any_expected_future_expenses: "Any expected future expenses",
    Total_expenses: "Total expenses",
    Asset_manufacturer: "Vehicle manufacturer",
    Asset_model: "Vehicle model",
    Asset_model_type: "Vehicle model type",
    Asset_color: "Vehicle color",
    Asset_condition: "Vehicle condition",
    Asset_price: "Vehicle price",
    Asset_model_year: "Vehicle model year",
    Chassis_number: "Chassis number",
    Down_payment: "Down payment",
    Ballon_payment: "Ballon payment",
    Dealer_name: "Dealer name",
    Document: "document",
    First_name: "First name",
    Middle_name: "Middle name",
    Family_name: "Family name",
    ID_type: "ID type",
    ID: "ID",
    ID_number: "ID number",
    Phone: "Phone",
    Email: "Email",
    Select_Marital: "Select your marital status.",
    Pick_Dependents: "Pick the number of dependents.",
    ONLY_CHARACTERS_ALLOWED: "Only characters allowed.",
    CANNOT_BE_EMPTY: "Cannot be empty.",
    Only_Arabic: "Only Arabic allowed.",
    MAX_12_MONTHS: "Must be less than or equal 12 months",
    MAX_36_MONTHS: "Must be less than or equal 36 months",
    MAX_60_MONTHS: "Must be less than or equal 60 months",
    IBAN_22: "IBAN must consist of 22 letters or numbers.",
    IBAN_ALPHANUMERIC_ONLY: "IBAN must contain only alphanumeric characters.",
    IBAN_ONLY_NUMBERS: "IBAN must contain only numbers.",
    MUST_BE_INTEGER: "Must be an integer",
    MUST_BE_ATLEAST: "Must be at least 25,000",
    MUST_BE_ATLEAST_3000: "Must be at least 3000",
    MUST_BE_ATLEAST_5000: "Must be at least 5000",
    MUST_BE_ATLEAST_3500: "Must be at least 3500",
    MUST_BE_ATLEAST_20000: "Must be at least 20000",
    // Generic dynamic-range messages used by V2 vendor-driven product pages.
    // Specific min/max is shown in the requested-amount notice card, so the error stays generic.
    MUST_BE_ATLEAST_AMOUNT: "Amount is below the minimum allowed for this vendor",
    CANNOT_EXCEED_AMOUNT: "Amount exceeds the maximum allowed for this vendor",
    MUST_BE_8_DIGITS: "Must be atleast 8 digits",
    MUST_BE_BETWEEN_8_AND_10_DIGITS: "Must be between 8 to 10 digits",
    CHASSIS_NUMBER_INVALID: "Must be up to 17 letters or numbers",
    CANNOT_EXCEED: "Cannot exceed 7 digits",
    CANNOT_EXCEED_500000: "Cannot exceed more than 500000",
    CANNOT_EXCEED_50000: "Cannot exceed more than 50000",
    CANNOT_EXCEED_30000: " Cannot exceed more than 30000",
    CANNOT_EXCEED_80000: "Cannot exceed more than 80000",
    CANNOT_EXCEED_20000: "Cannot exceed more than 20000",
    CANNOT_EXCEED_4: "Cannot exceed 4 digits",
    MUST_BE_ATLEAST_0: "Must be at least 0",
    CANNOT_EXCEED_7: "Cannot exceed 7 digits",
    CANNOT_EXCEED_50: "Cannot exceed 50 characters.",
    DOWN_PAYMENT_20:
      "Down payment should be 3K or above or it can be zero And should less than Vehicle Price",
    BALLON_PAYMENT_40: "Ballon Payment must be 40% or less than assetPrice",
    BALLON_REQUIRED: "Ballon Payment is required",
    DOWN_PAYMENT_REQUIRED: "Down Payment is required",
    NAME_REQUIRED: "Name is required.",
    PHONE_REQUIRED: "Phone is required.",
    YOUR_NAME: "Your name",
    PLEASE_ENTER_NAME: "Please enter your name",
    YOUR_EMAIL: "Your email",
    USE_VALID_EMAIL: "Use a valid email",
    PLEASE_TYPE_EMAIL: "Please type your email",
    YOUR_GENDER: "Your gender",
    PLEASE_SELECT_GENDER: "Please select your gender",
    DO_YOU_HAVE_DEPENDENTS: "Do you have dependents?",
    NUMBER_OF_DEPENDENTS: "Number of dependents",
    LOADING_DETAILS: "Loading personal details...",
    LOADING_ADDRESS_DETAILS: "Loading address details...",
    LOADING_MARITAL_DETAILS: "Loading marital details...",
    LOADING_EMPLOYMENT_DETAILS: "Loading employment details...",
    LOADING_LOAN_DETAILS: "Loading loan details...",
    LOADING_FINANCIAL_DETAILS: "Loading financial details...",
    LOADING_AUTOLOAN_DETAILS: "Loading autoloan details...",
    LOADING_DOCUMENT_DETAILS: "Loading document details...",
    LOADING_ASSET_DETAILS: "Loading asset details...",
    City: "City",
    Marital_status: "Marital Status",
    Region: "Region",
    Title: "Title",
    Nationality: "Nationality",
    Number_of_dependents: "Number of dependents",
    Male: "Male",
    Femail: "Female",
    undefined: "",
    DOC_CONDITION_1: "Please attach the salary certificate",
    DOC_CONDITION_2: "Please attach the bank statement for the last 3 months",
    DOC_CONDITION_3:
      "If the requested amount for finance is 40,000 riyals or more",
    MAX_FILES_UPLOADED: "Maximum number of files uploaded.",
    LOAN_REASON: "Reason of Finance",
    LOAN_REASON_REQUIRED: "Finance reason is required",
    MANAGE_OFFERS_DES:
      "Receive the latest news and personalized offers from Tamweel Aloula",
    BANK_STATEMENT: "Bank Statement",
    PAY_SLIP: "Pay Slip",
    OTHER_DOCUMENTS: "Other Documents",
    SELECT_FILE: "Select File",
    REMOVE: "Remove",
    IVR_VERIFICATION_TITLE: "Verify Your Application",
    IVR_VERIFICATION_MESSAGE:
      "Please answer the IVR call you'll receive shortly to verify and accept your application.",
    CONTINUE: "Continue",
  },
  FORGOT_PASSWORD: {
    "Reset password": "Reset password",
    "Forgot password?": "Forgot password?",
    "Please, enter your phone": "Please, enter your phone",
    Send: "Send",
    "Return to sign in": "Return to sign in",
    "Cannot be empty": "Cannot be empty.",
    "Must be exactly 9 digits": "Must be exactly 9 digits",
    FORGOT_PASSWORD_LABEL: "Phone number registered in Absher",
    ONE_TIME_OTP: "We've sent your one-time password (OTP) by SMS",
    ONE_TIME_PASS: "Please, enter your new password",
    RESET: "Reset",
    PASSWORD: "Password",
    CONFIRM_PASSWORD: "Confirm Password",
  },
  City: "City",
  Marital_status: "Marital Status",
  Region: "Region",
  Title: "Title",
  Nationality: "Nationality",
  Number_of_dependents: "Number of dependents",
  Male: "Male",
  Femail: "Female",
  Employment_type: "Employment Type",
  Education_Level: "Education Level",
  Resident_Status: "Resident Status",
  Employment_Sector: "Employment Sector",
  Joining_Date: "Joining Date",
  "Select date": "Select date",
  "No Data": "No Data",
  "For Private Sector": "For Private Sector",
  APPLICATION_ALREADY_EXISTS: "You have application already exists",
  ACTIVE_APPLICATION: "You already have an active application.",
  APPLICATION_ALREADY_SUBMITTED: "Your application is already submitted",
  OFFER_PENDING_GENERATION: "Offer is pending generation.",
  CONTRACT_PENDING_GENERATION: "Contract is pending generation.",
  "Something went wrong": "Something went wrong",
  USER_ALREADY_EXISTS: "You already have an account, please login",
  DEVICE_ALREADY_REGISTERED: "please use your device for registration",
  OFFER: {
    Offering: "Offering",
    Product: "Product",
    KASTLENO: "App No",
    APPNO: "App No",
    CUSTOMERNAME: " Customer Name",
    ERRORLOADING: "Error loading Offer",
    NO_DATA_ALLOWED_ERR: "No data found for this segment.",
  },
  OFFER_TABLE: {
    APP_NO: "Application number",
    PRODUCT_NAME: "Product name",
    CONTRACT: "Contract",
    STATUS: "Status",
    OFFER: "Offer",
    REFRESH: "Refresh",
    DELETE: "Delete",
    VIEW_CONTRACT: "View Contract",
    EDIT: "Edit",

    CONFIRM: "Confirm?",
    CONFIRM_BTN: "Confirm",
    CANCEL: "Reject?",
    CANCEL_BTN: "Reject",
    CONFIRM_ACCEPTANCE: " Confirm Offer Acceptance?",
    CONFIRM_REJECTION: " Confirm Offer Rejection?",
    ACCEPT: "Accept",
  },
  CONTRACT: {
    CONTRACT: "CONTRACT",
    CONTRACT_ACCEPT: "Contract Accepted",
    CONTRACT_REJECT: "Contract Rejected",
    CONTRACT_ACCEPTANCE: "Do you confirm contract acceptance?",
    CONTRACT_ERROR: "Failed to accept the contract, please try again",
    CONTRACT_ERROR_REJECT: "Failed to reject the contract, please try again",
    CONFIRM: "Confirm",
    REJECT: "reject",
    CONFIRM_QUESTION: "Confirm?",
    REJECT_QUESTION: "Reject Contract?",
    CONFIRM_REJECTANCE: "Do you confirm contract rejection?",
  },
  PRODUCTS: {
    AUTO_DESC_SUB:
      "Auto lease financing enables you to own a new or used vehicle through our partnerships with numerous showrooms and agencies, offering flexible installment plans. This Sharia-compliant solution is available to both Saudis and residents of Saudi Arabia, with application options via digital channels or by visiting one of our branches.",
    MOTO_DESC_SUB:
      "Moto financing enables you to own a new or used vehicle through our partnerships with numerous showrooms and agencies, offering flexible installment plans. This Sharia-compliant solution is available to both Saudis and residents of Saudi Arabia, with application options via digital channels or by visiting one of our branches.",
    PERSONAL_DESC_SUB:
      "At tamweel al-oula Financing Company, we strive to provide easy financing solutions that enable everyone to quickly obtain funding. You can now apply for a personal financing product compliant with Islamic Sharia through digital application.",
    MICRO_DESC_SUB:
      "At tamweel al-oula Financing Company, we strive to provide easy financing solutions that enable everyone to quickly obtain funding. You can now apply for a auto financing product compliant with Islamic Sharia through digital application.",
    SCHOOL_DESC_SUB:
      "Simplify your school fee payments — apply today and spread the cost with easy monthly installments through Tamweel Aloula.",
    DENTAL_DESC_SUB:
      "Kenzel Dental lab Delivering precision and aesthetics through advanced CAD/CAM technology and premium materials. From implants to prosthetics, we ensure lasting comfort and global quality. Ideal for dental clinics, students, and distributors worldwide.",
    REQUESTED_AMOUNT_NOTICE_TITLE: "Requested Amount",
    REQUESTED_AMOUNT_NOTICE_TEXT:
      "Dear Customer, Kindly be informed that Requested Amount is transfer to the merchant.",
    AUTO_PT1: "Includes employees and retired individual.",
    AUTO_PT2: "Age of applicant must be between 21 and 60",
    AUTO_PT3: "Minimum salary of 3500 riyals.",
    AUTO_PT4:
      "The minimum financing amount is not less than 20,000 riyals, and the maximum financing amount is 500,000 riyals.",
    AUTO_PT5:
      "Duration of service is at least 4 months for the private sector and at least 3 months for the semi-governmental sector and at least 1 month for the governmental sector.",
    AUTO_PT6:
      "The APR ranges between 10% – 16% (insurance excluded) and varies according to financing amount and repayment period.",
    AUTO_PT7: "The repayment period ranges from 6 months to 60 months.",
    DENTAL_PT7: "Financing period from 6 months to 18 months.",
    AUTO_PT8: "The percentage of salary deduction is up to 45%.",

    PRSNL_PT1: "Includes employees and retired Saudis.",
    PRSNL_PT2: "Age of applicant must be between 21 and 60.",
    PRSNL_PT3: "Minimum salary of 4100 riyals.",
    PRSNL_PT4:
      "The minimum financing amount is 20,000 riyals for Saudi nationals and 5,000 riyals for non-Saudis, and the maximum financing amount is 500,000 riyals for Saudi nationals and 80,000 riyals for non-Saudis.",
    PRSNL_PT5:
      "Duration of service is at least 4 months for the private sector and at least 3 months for the semi-governmental sector and at least 1 month for the governmental sector.",
    PRSNL_PT6:
      "The APR ranges between 20% – 39% and varies according to financing amount and repayment period.",
    PRSNL_PT7: "The repayment period ranges from 6 months to 60 months.",

    MICRO_PT1: "Includes employees and retired Saudis.",
    MICRO_PT2: "Age of applicant must be between 20 and 60.",
    MICRO_PT3: "Minimum salary of 3500 riyals.",
    MICRO_PT4:
      "The minimum financing amount is not less than 5,000 riyals, and the maximum financing amount is 20,000 riyals.",
    MICRO_PT5:
      "The repayment period ranges from 6, 12, 18, months to 24 months.",
  },
  EDUCATIONAL: {
    SCHOOL_DESC_SUB:
      "Installment your educational payments with Al-Aoual Financing, compliant with Islamic Sharia and with a competitive profit margin.",
    AUTO_PT1: "Includes employees and retired individual.",
    AUTO_PT2: "Age of applicant must be between 20 and 60",
    AUTO_PT3: "Minimum salary of 3690 riyals.",
    AUTO_PT4:
      "The minimum financing amount is not less than 3,000 riyals, and the maximum financing amount is 500,000 riyals.",
    //added point 4 again because they have different minimum limit for the educational and kenzel products
    AUTO_PT4_KENZEL:
      "The minimum financing amount is not less than 3,500 riyals, and the maximum financing amount is 500,000 riyals.",
    AUTO_PT5:
      "Duration of service is at least 3 months for the private sector and at least 1 month for the semi-governmental sector and at least 1 month for the governmental sector.",
    AUTO_PT6: "Customer Profit Rate: 0%",
    AUTO_PT7: "Financing Duration from 6 months to 10 months.",
    AUTO_PT8:
      "Monthly installment must not exceed 45% of the customer’s total monthly obligations (DBR) / 65% if the customer has mortgage",
  },
  PRODUCT_NAME: "Product name",
  ACTIONS: "Actions",
  DELETE: "Delete",
  REFRESH: "Refresh",
  VIEW_CONTRACT: "View contract",
  REQUEST_DETAILS: {
    DETAILS: "Request details",
    REQUEST_NUMBER: "Request number",
    CUSTOMERNAME: "Full name",
    EMAIL: "Email",
    IDNUMBER: "Iqama Number",
    DATE_OF_EXPIRY: "Expiry Date",
    IBAN: "IBAN",
    GENDER: "Gender",
    MOBILE: "Mobile No.",
    FOOD_EXPENSES: "Food Expenses",
    HOUSING_EXPENSES: "Housing expenses",
    DOMESTIC_WORKERS: "Domestic workers",
    EDUCATION_EXPENSES: "Education expenses",
    HEALTHCARE_EXPENSES: "Health care expenses",
    COMM_TRANS_EXPENSES: "Communication and transportation expenses",
    INSURANCE_EXPENSES: "Insurance expenses",
    FUTURE_EXPENSES: "Any expected future expenses",
    EMPCATID: "Employment type",
    SECTORID: "Employment Sector",
    DATEOFJOINING: "Date of Joining",
    QUALIFICATIONID: "Education Level",
    RESIDENTID: "Resident Status",
    PRODUCTID: "Type of finance",
    SUBPRODUCTID: "Facility",
    REQUESTED_AMOUNT: "Requested finance amount",
    TENURE: "Tenure (in months)",
    ASSET_MANUFACTURER: "Vehcile manufacturer",
    ASSET_MODEL: "Vehcile model",
    ASSET_MODEL_TYPE: "Vehcile model type",
    COLORID: "Vehcile color",
    ASSET_CONDITION: "Vehcile condition",
    ASSET_PRICE: "Vehcile price",
    ASSET_MODEL_YEAR: "Vehcile model year",
    DOWN_PAYMENT: "Down payment",
    BALLOON_PAYMENT: "Balloon payment",
    DEALERID: "Dealer name",
  },
  VIEW_OFFER: {
    FINANCE_AMOUNT: "Finance Amount",
    DOWN_PAYMENT: "Down Payment",
    BALLOON_PAYMENT: "Balloon Payment",
    EMI: "EMI",
    AGREEMENT_TOTAL: "Agreement Total",
    TENURE: "Tenure",
    NO_DATA_FOUND: "No data found for this segment.",
    APR: "APR",
  },
  LOADING: "Loading...",
  SETTINGS: {
    READ_MORE: "Read More",
    USER_PROFILE: "User Profile",
    Full_Name: "Full Name",
    Address: "Address",
    Birth_Date: "Birth Date",
    Mobile_Number: "Mobile Number",
    RESET_PASSWORD: "Reset Password",
    SUBMIT: "Submit",
    OLD_PASSWORD: "Old Password",
    PLEASE_ENTER_OLD_PASSWORD: "Please enter your old password",
    NEW_PASSWORD: "New Password",
    PLEASE_ENTER_NEW_PASSWORD: "Please enter your new password",
    PASSWORDS_MUST_MATCH: "Passwords must match",
    PLEASE_CONFIRM_PASSWORD: "Please enter confirm password",
    CONFIRM_PASSWORD: "Confirm Password",
    WE_HAVE_SENT: "We've sent your one-time password (OTP) by SMS",
    ENTER_OTP: "Enter OTP",
    SUBMIT_OTP: "Submit OTP",
    //new setting design text
    REPAYMENT: "Repayment",
    SETTINGS: "Settings",
    PERSONAL_DATA: "Personal Data",
    PERSONAL_DATA_DES: "Manage your Name and ID Number... etc",
    ADDRESS_DETAILS: "Address Details",
    ADDRESS_DETAILS_DES: "Manage your Residence place",
    MARITAL_STATUS: "Marital Status",
    MARITAL_STATUS_DES: "Manage your Marital Status and dependents Number",
    ELIGIBILITY: "Eligibility",
    ELIGIBILITY_DES: "Manage your Employment and payment details",
    DOCUMENT: "Document",
    DOCUMENT_DES: "View All of your document",
    DOCUMENT_DES_V2: "(Only PDF files allowed, up to 3 MB)",
    TERMS_AND_CONDITION: "Terms & Condition",
    TERMS_AND_CONDITION_DES: "View tamweel terms and condition",
    MANAGE_OFFERS: "Offers Management",
    MANAGE_OFFERS_DES: "Offers and subscriptions Management",
    INSTALLMENT_DASHBOARD: "Installment details",
    INSTALLMENT_DASHBOARD_DES:
      "Receive installments paid and non paid installments ",
    INSTLMNT_DASHBOADRD_SUMMARY: "Installment Summary",
    INSTALLMENT_DATA_UNAVAILABLE: "Installment data is unavailable",
    INSTALLMENT_DATA_UNAVAILABLE_DESC:
      "There are currently no installment records available for this application.",
    CONTACT_US: "Contact Us",
    CONTACT_US_DES: "We will answer your questions and problems",
    CHECK_BACK_LATER: "Please check back later.",
    NO_SIGNED_APPLICATIONS_FOUND: "No signed applications found",
    SELECT_ONE_APPLICATION: "Please select one application",
    APPLICATION_ID: "Application ID",
    NO_APPLICATION_FOUND_TITLE: "No Application Found",
    NO_APPLICATION_FOUND_DESC:
    "No applications are available at the moment. Start a new application to see it listed here.",
    FAQ: "FAQ",
    FAQ_DES: "Manage your Marital Status and dependents NO.",
    HELP_AND_SUPPORT: "Help & Support",
    HELP_AND_SUPPORT_DES: "View tamweel contacts",
    ADDRESS_DETAIL: "Address Detail",
    SAVE: "Save",
    HIJRI_DOB: "Hijri DoB",
    GEORGIAN_DOB: "Georgian DoB",
    GENERAL_INFO: "General Information",
    CUSTOMER_DETAIL: "Customer Details",
    CONTACT_US: "Contact Us",
    CONTACT_DES: "24/7 We will answer your questions and problems",
    CONTACT_CARD1: "Sales Units Number",
    CONTACT_CARD2: "Customer Care Center",
    CONTACT_CARD3: "For inquiries about after-sales services and complaints",
    VIEW: "View Document",
    CHANGE_PASSWORD: "Change Password",
    CHANGE_PASSWORD_DES: "Manage you Password",
    LOADING_DOCUMENT: "Loading Document",
    NO_DOCUMENTS_AVAILABLE: "No documents available",
    DOCUMENTS_DRAG_DROP_HEADING: "Click to Upload or drag and drop",
    DOCUMENTS_DRAG_DROP_TEXT:
    "(The customer can uploaded relevant documents when requested, only PDF and .Jpeg .PNG can be uploaded. The size should be within 3MB.)",
    ERROR_FILE_TYPE: "You can only upload JPG/PNG/PDF files!",
    ERROR_FILE_SIZE_3MB: "File must be smaller than 3MB!",
    ERROR_FILE_MULTIPLE_EXT:
      "Files with multiple extensions are not allowed.Please rename the file.",
      ERROR_FILE_NAME_CONTRACT:
      "File name should not contain the word 'contract'.",
      ERROR_DUPLICATE_FILE_NAME:
      "A file with the same name already exists. Please rename the file or choose a different one.",
      FILE_UPLOAD_ERROR: "Failed to upload file.",
      FILE_UPLOAD_SUCCESS: "File uploaded successfully.",
      ERROR_NO_FILE_ADDED: "No file added.",
      BACK: "Back",
      ALL_RIGHTS_RESERVED: "All rights reserved",
      INSTALLMENT_NUMBER: "Installment No",
      INSTALLMENT_DUE_DATE: "Due Date",
      INSTALLMENT_AMOUNT: "Amount",
      INSTALLMENT_STATUS: "Status",
      //Changed this to repayment schedule
      // INSTALLMENT_DETAILS: "Installment Details",
      REPAYMENT_SCHEDULE: "Repayment Schedule",
      BACK_TO_HOME: "Back to Home",
      CONTRACT_AMOUNT: "Contract Amount",
      REMAINING_AMOUNT: "Remaining Amount",
      PAID_AMOUNT: "Paid Amount",
      NEXT_PAYMENT_DUE: "Next Payment Due",
      REPAYMENT_STATUS: "Repayment Status",
      NEXT_PAYMENT_DATE: "Next Payment Date",
      PAID: "Paid",
      UPCOMING: "Upcoming",
      REMAINING: "Remaining",
      REPAYMENT_PROGRESS: "Repayment Progress",
      SALARY_INFO: "Salary Info",
      SALARY_INFO_DES: "Update or edit salary",
      CURRENT_SALARY: "Current salary",
      CURRENT_SALARY_PLACEHOLDER: "Please enter your current salary",
      EDIT_SALARY: "Edit Salary",
      UPDATE_SALARY: "Update Salary",
      SALARY_UPDATE_SUCCESS: "Salary Updated Successfully",
      SALARY_UPDATE_FAILED: "Unable to update salary, please try again",
      SALARY_LOAD_FAILED: "Unable to load salary, please try again",
      SALARY_REQUIRED: "Please enter your salary",
      SALARY_OUT_OF_RANGE: "Salary must be between 2,800 and 100,000",
      SALARY_LOCKED: "You can change your salary only once every 30 days.",
      SALARY_NEXT_UPDATE: "You can update it again on",
  },
  SALARY_ELIGIBILITY: {
    TITLE: "Monthly Salary Information",
    DESC: "Please enter your monthly salary to check your eligibility before proceeding with your application.",
    CURRENT_SALARY: "Current salary",
    SALARY_PLACEHOLDER: "Please enter your current salary",
    PROCEED: "Proceed",
    SALARY_REQUIRED: "Please enter your monthly salary",
    SALARY_OUT_OF_RANGE: "Salary must be between 2,800 and 100,000",
    CHECK_FAILED: "Unable to check eligibility, please try again",
    NOT_ELIGIBLE_TITLE: "Not eligible to apply for this product",
    NOT_ELIGIBLE_DESC: "Your monthly income is below the minimum salary requirement.",
    NOT_ELIGIBLE_ALT_PREFIX:
      "Your salary is below the minimum requirement. However, you're eligible for",
    CONTINUE: "Continue",
    AND: "and",
    PRODUCT_TWQ: "Personal Finance",
    PRODUCT_MICRO: "Microfinance",
    PRODUCT_IJARAH: "Ijarah",
    PRODUCT_MUR: "Murabaha",
  },
  VALIDATION: {
    AGE_REQUIREMENT: "You must be at least 18 years old",
    CANNOT_BE_EMPTY: "Cannot be empty",
    INCORRECT_LENGTH: "Incorrect length.",
    ID_STARTS_1_OR_2: "ID must start with 1 or 2.",
    MUST_BE_CHECKED: "Must be checked.",
    EMAILS_DO_NOT_MATCH: "Emails do not match.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    PASSWORD_REQUIREMENTS:
      "Password must have at least 8 characters, Two alphabetic characters; one uppercase and one lowercase, One digit and One special character.",
    INVALID_EMAIL_ADDRESS: "Not a valid email address.",
    INVALID_PHONE_NUMBER: "The phone number is invalid.",
    PHONE_MUST_START_WITH_966: "Phone number must start with 966.",
    FILL_REQUIRED_FIELDS: "Please fill in all required fields.",
    IBAN_VAL_FAILED: "IBAN verification failed. Please enter correct IBAN.",
    IBAN_VAL_SUCCESS: "IBAN successfully verified",
  },
  INPUTS: {
    DAY: "Day",
    MONTH: "Month",
    YEAR: "Year",
  },
  MONTHS: {
    JANUARY: "January",
    FEBRUARY: "February",
    MARCH: "March",
    APRIL: "April",
    MAY: "May",
    JUNE: "June",
    JULY: "July",
    AUGUST: "August",
    SEPTEMBER: "September",
    OCTOBER: "October",
    NOVEMBER: "November",
    DECEMBER: "December",
  },

  privacy_note: {
    title_1: "Privacy notice",
    title: "Privacy notice",
    content:
      "Tamweel Aloula Company is a limited joint-stock company licensed and subject to the supervision and oversight of the Saudi Central Bank under C.R. No. 2050055043. Tamweel Aloula provides digital financing solutions for individuals and corporate.\n" +
      'Tamweel Aloula (hereafter referred to as "we" or “our” or "us" or “organization” respects your right to data privacy. In this Notice “You” or “Your” refers to the data subject whose personal data is processed by Tamweel Aloula.\n' +
      "This Privacy Notice (“Notice”) provides information about how Tamweel Aloula handles personal information about you and describes the rights you may have regarding your personal information. This Notice applies to Tamweel Aloula and its online and offline collection, use, and disclosure of personal information.\n" +
      "Tamweel Aloula has an obligation to preserve the confidentiality and privacy of the user's data and information.\n" +
      "Tamweel Aloula shall not collect, process or disclose any personal data or information except in accordance with the specific controls provided in the instructions governing the confidentiality of information issued by the regulatory authorities in the Kingdom like PDPL and NDMO, including all amendments applicable to them from time to time.\n",
  },
  personal_data_collection_processing_disclosures: {
    title: "Personal Data Collection, Processing & Disclosures",
    collection: {
      title: "When does Tamweel Aloula Collect Personal Information About You",
      content:
        "This information is collected when you utilize our services through online and offline channels including the conditions when your personal information is shared by members within Tamweel Aloula.",
    },
    types: {
      title:
        "What Types of Personal Information does Tamweel Aloula Collect and Retain",
      content_1:
        "\tWhen you interact with us, we may collect information to help identify and contact you, including, but not limited to, your name, email address, physical address, telephone number (landline and/or mobile), and ID Number.",
      content_2:
        "\tIf you create an account, we may collect your username, password, date of birth, and National Identification information to provide you with our services.",
      content_3:
        "\tWe also may collect information about the device you use to access our online services. This includes device ID, advertising ID, and browser details while using our online services.",
      content_4:
        "\tWe may collect your IP address and information related to that IP address, such as geographical information and domain information.",
      content_5:
        "\tWe may collect different types of personal information about you from various sources. Given below are the further categories of personal information we may have collected through different sources.",
      content_6:
        "\tWe may collect different types of personal information about you from various sources. Given below are the further categories of personal information we may have collected through different sources.",
    },
    methods: {
      title: "Methods of collecting personal data",
      direct: {
        title: "Information you provide directly (the Data Subject):",
        content:
          "This includes information submitted by completing the electronic forms on our website or by contacting us through other channels such as email or phone calls.",
      },
      indirect: {
        title: "Information we collect indirectly about you:",
        content:
          "Your information from organizations (Banks, Lending organizations, Insurance providers, Telecommunication companies), and from Private companies with national ownerships such as ELM and others.",
      },
    },
  },
  personal_information_collection: {
    title: "Personal Information We Collect and From Whom We Collect It",
    what_we_collect: {
      title: "What We may collect",
      content_1:
        "\tIdentity information (Name including first, last, and/or maiden name, Date of birth, National ID Number, Marital Status)",
      content_2: "\tDemographic Information (age, gender, and nationality)",
      content_3:
        "\tContact information (National address, email address (es), telephone number(s)).",
      content_4:
        "\tCompany information (Name, Address, location, type of assets sold, CR Number, Phone numbers, Emails, Websites, Financial Statements, Income, and market value of the land).",
      content_5: "\tInformation collected via cookies.",
      content_6:
        "\tProfessional Employment details (Employment Dates, Employer Name, Employer Information)",
      content_7:
        "\tFinancial details (Bank account details, financial statements, income, credit history, loan or credit application data, Salary information)",
      content_8:
        "\tAudio and electronic recording, for example, when you call in with a question to customer service.",
      content_9: "o\tVideo recording for service delivery purposes.",
    },
    from_whom: {
      title: "From Whom We Collect It",
      content_1: "\tInformation you provide.",
      content_2:
        "\tYour information from member organizations (Banks, Lending organizations, Insurance providers, Telecommunication companies), and from Private companies with national ownerships such as ELM and SIMAH.",
    },
    purpose: {
      title:
        "Purpose for Collecting & Processing Personal Information",
        subTitle: "We collect your personal information for different purposes as mentioned below:",
      content_1:
        "\tFor customer onboarding purposes / customer registration purposes.",
      content_2: "\tTo verify your identity.",
      content_3: "\tFor processing loan or insurance application.",
      content_4:
        "\tTo detect, investigate, prevent fraud by monitoring, recording voice, electronic communications, screening applications, transactions.",
      content_5:
        "\tTo record and demonstrate how we have conducted the dispute and complaint resolution process and arrived at a resolution.",
      content_6:
        "\tTo comply with business, legal, and regulatory requirements incumbent upon Tamweel Aloula.",
      content_7:
        "\tFor product development and research, and for any purpose subject to the limitations set forth in this Notice and applicable laws incumbent upon Tamweel Aloula.",
      content_8:
        "\tFor fulfillment of your requests, transactional and other communications about our websites and online services.",
      content_9:
        "Your personal data except sensitive data may be used for marketing purposes. ",
      content_10:
        "Your personal data may be used for Automated decision-making. ",
    },
  },
  purpose_collecting_processing: {
    // title: "Purpose for Collecting & Processing Personal Information",
    // content:
    //   "To detect, investigate, prevent fraud by monitoring, recording voice, electronic communications, screening applications, transactions.",
    legal_basis: {
      title: "Legal Basis for Processing Personal Data",
      content:
        "Tamweel Aloula processes your personal data in accordance with specific legal grounds, including contract execution, regulatory compliance, protection of fundamental interests, consent, and legitimate interests.",
    },
    data_protection: {
      title: "Personal Data Protection",
      content:
        "Tamweel Aloula is committed to protecting the personal data from unauthorized access, use, or disclosure, in accordance with security standards and the requirements of the National Cybersecurity Authority and the Saudi Central Bank (SAMA).",
    },
  },
  data_retention: {
    title: "How Long Does Tamweel Aloula Keep Personal Information?",
    content:
      "Tamweel Aloula will keep your information in accordance to the PDPL regulations or as long as we need it for legal, monitoring fraud, and also for regulatory purposes as instructed by regulatory authority i.e. SAMA.",
    content_2:
      "We will actively review the information we hold and delete it securely when there is no longer a legal, or regulatory need for it to be retained.",
  },
  data_sharing: {
    title: "With whom does Tamweel Aloula share Your Personal Information?",
    content:
      "Tamweel Aloula shares your personal information with different member organizations including identity verification authorities, financial investigation companies, banks, credit history service providers, trusted cloud service providers, and KSA regulatory authorities to whom you consent to disclose your personal data. Prior to sharing personal data with these member organizations, we review the services performed by such member organizations and require that the member organizations keep personal data confidential and secure and not use it for any purpose except performing the services. Disclosure for Legal reasons: We may share personal data with third parties to comply with valid legal requirements such as Saudi law, regulations, search warrants, subpoenas, court orders, or other legal processes. Tamweel Aloula may transfer, and process some of the personal data outside the Kingdom, and will take all necessary measures to ensure that such transfer is carried out in accordance with applicable regulations, while providing an adequate level of protection for your personal data.",
  },
  minors_privacy: {
    title: "Minor’s Privacy",
    content:
      "We are concerned about protecting the privacy of Minors. The Website is not directed to individuals that are under the age, and we do not knowingly collect Personal Information from such individuals.",
  },
  changes_notice: {
    title: "Will We Inform You of Changes to This Privacy Notice?",
    content:
      "If we change this Privacy Notice, we will let you know about the changes by publishing the updated version at all applicable communication channels. Tamweel Aloula is committed to protecting and respecting your privacy.",
  },
  data_subject_choices: {
    title: "Choices Available to Owners of Personal Data",
    title_content:
      "Under Saudi Arabia's Personal Data Protection Law, the owners of personal data are entitled to the below rights. However, the rights to the data subject shall be disbursed in accordance with the regulatory and legal obligations incumbent upon Tamweel Aloula.",
    choice_1:
      "\tRight to request information on the processing activities carried out with their personal data.",
    choice_2: "\tRight to request access to their personal data.",
    choice_3: "\tRight to request provision of personal data.",
    choice_4:
      "\tRight to request correction, updating, or completion of their personal data.",
    choice_5: "\tRight to request erasure of personal data in specific cases.",
    choice_6: "\tRight to withdraw consent in specific cases.",
    content:
      'For any questions or complaints, please contact the Data Protection Officer via the "Contact Us" tab on our website.',
    para_1:
      "You may withdraw your consent to receive marketing communications at any time by accessing your profile through Tamweel Aloula's website or mobile application and managing your offers preferences.",
    para_2:
      "You have the right to withdraw your consent to the processing of your personal data at any time, unless there are legal grounds or regulatory requirements that necessitate the continuation of such processing.",
    para_3:
      'For any inquiries, complaints, or requests related to personal data, you may contact the Data Protection Officer via the "Contact Us" tab on our website.',
    para_4:
      "Tamweel Aloula ensures that your requests to exercise your rights are processed within 30 days, with the possibility of an additional 30-day extension if needed, along with prior notice explaining the reason.",
    para_5:
      "If you are not satisfied with how your request or complaint is handled, or if we fail to respond within the specified time, you may submit a complaint to the Saudi Central Bank (SAMA).",
  },
  data_access_correction: {
    title:
      "Methods For Accessing, Correcting, Or Modifying Personal Information",
    content:
      "If you believe any information on your personal credit report is inaccurate or incomplete, you can raise a dispute case and tell us specifically why you think it’s inaccurate or incomplete.\n" +
      'You can contact us via the "Contact Us" tab on our website.\n',
  },
  last_updated: {
    content:
      "Last Updated: February 2026. This notice may be amended from time to time to reflect legal, regulatory, or operational changes.",
  },
  UPLOAD_DOCUMENT: "Upload document",
  APPLY: "Apply",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  CLOSE: "Close",
  SUBMIT: "Submit",
  STEP_OFFER: "Offer",
  STEP_CONTRACT: "Contract",
  DISBURSEMENNT: "Disbursement",
  STEP_DONE: "Done",
  QARAR_COMMENTS: "Qarar Comments",
  REJECTION_REASON: "Rejection Reason",
  STEPPER: {
    STATUS: {
      PENDING: "Pending",
      ACCEPTED: "Accepted",
      REJECTED: "Rejected",
      DISBURSED: "Disbursed",
      SIGNED: "Signed",
    },
    DESC: {
      SUBMIT_DEFAULT: "Your application has been received and is under review.",
      SUBMIT_ACCEPTED:
        "Your application has been verified and accepted successfully.",
      SUBMIT_PENDING:
        "Your application is awaiting verification. Please answer the IVR call.",
      SUBMIT_REJECTED:
        "Unfortunately, your application verification was not successful.",
      OFFER_DEFAULT:
        "Your offer is ready. Please review the details to proceed.",
      OFFER_ACCEPTED:
        "The offer has been accepted successfully. Proceeding to contract.",
      OFFER_PENDING:
        "Your offer is being prepared. Please wait for the details.",
      OFFER_REJECTED: "The offer was rejected or has expired.",
      CONTRACT_DEFAULT:
        "Sign the contract to confirm your agreement and continue.",
      CONTRACT_SIGNED: "You have signed the contract successfully.",
      CONTRACT_PENDING: "Your contract is being prepared. Please wait.",
      CONTRACT_REJECTED: "The contract was rejected or has expired.",
      DISBURSEMENT_DEFAULT:
        "After contract approval, the disbursement will be completed.",
      DISBURSEMENT_COMPLETED:
        "Congratulations! The disbursement has been completed successfully.",
    },
  },
  SHARED: {
    SEARCH: "Search",
    ONE: "1",
    TWO: "2",
    THREE: "3",
    FOUR: "4",
  },
  PROVIDERS: {
    PROVIDERS: "Providers",
    SUBMIT_APPL_SUCEESS: "Application Submitted successfully.",
    SUBMIT_APPL_ERROR: "Failed. Please try again.",
    NO_DATA_FOUND: "No Data Found",
  },
  VOUCHERS: {
    VOUCHERS: "Vouchers",
    SHERIZERO_PT1: "0% Profit Rate",
    SHERIZERO_PT2: "Provide you access to more than",
    SHERIZERO_PT4: "4 to 12 months tenure",
    FIVE_THOUSAND: "5000",
    STARTS_FROM: "Starts from",
    APPLY_NOW: "Apply now",
    COMING_SOON: "Coming soon",
    COMING_SOON_MSG: "This service is coming soon!",
    EIGHTY_FIVE_MERCHANTS: "85 merchants",
    FOUR_HUNDRED_MERCHANTS: "400 merchants",
    FILL_FORM: "PLEASE FILL OUT THE FOLLOWING FORM",
    SHERI_PT1: "APR starts from 15.08%",
    SHERI_PT2: "From 6 to 60 Months tenure",
    MAX_LIMIT: "Max amount",
    FIVE_HUNDRED_THOUSAND: "500,000",
  },
  MERCHANTS: {
    BEST_SELLERS: "Best Sellers",
    PROVIDERS: "Providers",
    ALL_CARDS: "Merchants",
    SEARCH_BY_NAME: "Search Merchants by name",
  },
  PRE: {
    WELCOME: "Welcome to Tamweel!",
    DESCRIPTION: "Follow these steps to finalize profile setup:",
    STARTED: "Follow these steps to finalize profile setup:",
    PERSONAL_DATA_HEADING: "Follow these steps to finalize profile setup:",
    PERSONAL_DATA_DESCRIPTION: "Manage your Name and ID Number... etc:",
    ADDRESS_DTL_HEADING: "Address Details",
    ADDRESS_DTL_DESCRIPTION: "Manage your Residence place",
    MARITAL_STATUS_HEADING: "Marital Status",
    MARITAL_STATUS_DESCRIPTION:
      "Manage your Marital Status and dependents Number",
    ELIGIBILITY_HEADING: "Eligibility",
    ELIGIBILITY_DESCRIPTION: "Manage your Employment and payment details",
    INCOMPLETE_STEPS:
      "Please complete all required steps before proceeding with your application.",
  },
};

export default locale;